import React from 'react';
import { ConfirmDialog } from '../../../common/ConfirmDialog';
import { CONFIRM_DIALOG, ConfirmDialogType, TooManyRequestsTimer } from './FilterActions.types';
import { TranslateFn } from './filterActionsHelpers';

interface FilterActionsExportDialogProps {
  dialogVisible: ConfirmDialogType;
  tooManyRequestsTimer: TooManyRequestsTimer | undefined;
  translate: TranslateFn;
  onConfirm: () => void;
}

export const FilterActionsExportDialog: React.FC<FilterActionsExportDialogProps> = ({
  dialogVisible,
  tooManyRequestsTimer,
  translate,
  onConfirm
}) => {
  const isMaxExport = dialogVisible === CONFIRM_DIALOG.MAX_EXPORT_ITEMS;
  const timerSuffix = tooManyRequestsTimer ? ` (${tooManyRequestsTimer.timeLeft}s)` : '';

  return (
    <ConfirmDialog
      className="filterActionsDialog"
      title={translate(
        isMaxExport
          ? 'custom.toolbar.actions.export.maxExportItems.dialogHeader'
          : 'custom.toolbar.actions.export.tooManyRequests.dialogHeader'
      )}
      message={`${translate(
        isMaxExport
          ? 'custom.toolbar.actions.export.maxExportItems.dialogBody'
          : 'custom.toolbar.actions.export.tooManyRequests.dialogBody'
      )}${timerSuffix}`}
      confirmButtonOnly={true}
      onConfirm={onConfirm}
    />
  );
};
